import React from 'react'
import { useState } from 'react';
import ReactHtmlParser from 'react-html-parser';
// const apiData = [
//     {
//         title: "Mobile Application Developer",
//         hiring: 1,
//         content: `
//       <h6 style={{ color: "#737679" }}>
//         Opening for Mobile Application Developer for Noida Location
//         Interested candidates can share updated resume on mailto:
//         hralobha@alobhatechnologies.com kindly find the job
//         description mentioned below.
//       </h6>
//       <p>
//         <b>Responsibilities include:</b>
//       </p>
//       <p>
//         – Must have work experience with Flutter SDK and Dart
//         programming language.
//       </p>
//       <p>– Experience with third-party libraries and APIs.</p>
//       <p>– Experience working with Firebase database</p>
//       <p>
//         – Strong knowledge on Flutter widgets for both Android/iOS
//       </p>
//       <p>– Good knowledge in OOPS concepts</p>
//       <p>– Shall we able to write modular and concise code</p>
//       <p>– Perform full life-cycle development</p>
//       <p>– Adhere to agreed upon delivery schedules</p>
//       <p>
//         – Utilizes source control, continuous integration, and unit
//         testing best practices.
//       </p>
//       <p>
//         – Work cross-functionally to define and write code for new
//         features.
//       </p>
//     `
//     }, {
//         title: `Flutter Developer`,
//         hiring: 1,
//         content: `
//       <p>
//                           <b style={{ color: "#f27135" }}>
//                             Job Role &amp; Responsibilities:
//                           </b>
//                         </p>
//                         <p>
//                           – Design and develop high-volume, low-latency applications
//                           for mission-critical systems, delivering high-availability
//                           and performance.
//                         </p>
//                         <p>
//                           – Must have work experience with Flutter SDK and Dart
//                           programming language.
//                         </p>
//                         <p>– Experience with third-party libraries and APIs</p>
//                         <p>– Experience working with Firebase database</p>
//                         <p>
//                           – Strong knowledge on Flutter widgets for both Android/iOS
//                         </p>
//                         <p>
//                           – Knowledge on building flutter modules and flutter
//                           plug-ins.
//                         </p>
//                         <p>– Good knowledge in OOPS concepts</p>
//                         <p>– hall we able to write modular and concise code</p>
//                         <p>– Perform full life-cycle development</p>
//                         <p>– Adhere to agree upon delivery schedules</p>
//                         <p>
//                           – Utilizes source control, continuous integration, and unit
//                           testing best practices
//                         </p>
//                         <p>
//                           – Work cross-functionally to define and write code for new
//                           features
//                         </p>
//                         <p>
//                           – Support continuous improvement by investigating
//                           alternatives and technologies and presenting these for
//                           architectural review
//                         </p>
//                         <p>
//                           – Collaborate with team members (product managers,
//                           developers, designers) to brainstorm about new features and
//                           functionalities.s
//                         </p>
//                         <p>
//                           <b style={{ color: "#f27135" }}>Requirement</b>
//                         </p>
//                         <p>– Experience required- 2 - 3 years</p>
//                         <p>
//                           – B. Tech, MCA, M. Tech degree in Computer Science
//                           Engineering or a related subject
//                         </p>
//                         <p>– Proficient in Java/Kotlin programming</p>
//                         <p>
//                           – Knowledge and experience in Flutter Framework and DART
//                           programming
//                         </p>
//                         <p>
//                           – Hands on experience in using RESTful APIs/SDLC/iOS
//                           Integration/Agile Development.
//                         </p>
//                         <p>
//                           – Hands on experience in designing and developing
//                           micro-services architecture and containers
//                         </p>
//                         <p>
//                           – Object oriented analysis, UML and design using common
//                           design patterns.
//                         </p>
//                         <p>
//                           – Hands on experience in development IDE Android Studio,
//                           Android SDK, Firebase Test Lab
//                         </p>
//                         <p>– Good team working and critical thinking skills.</p>
//                         <p>– Min. Graduation</p>
//                         <p>– Job Type: Full-time</p>
//                         <p>– Salary: Payment will be best in industry</p>
//                         <p>– Job Location: Noida</p>
//                         <p>
//                           – Interested candidates can share updated resume on mailto:
//                           hralobha@alobhatechnologies.com{" "}
//                         </p>
//       `
//     }, {
//         title: `Business Development Executive`,
//         hiring: 1,
//         content: `
      
//       <p>
//                           <b>Required Candidate Profile:</b>
//                         </p>
//                         <p>
//                           – Wonderful opportunity for fresher's as well experienced
//                           candidates in Noida.
//                         </p>
//                         <p>– BBA / MBA college pass out (Marketing or IB);</p>
//                         <p>– Excellent communication skills</p>
//                         <p>– In mix of B2B and B2C market.</p>
//                         <p>
//                           – Comfortable working on, Telesales, Field Sales and Direct
//                           Sales.
//                         </p>
//                         <p>– Excellent English Communication Skills</p>
//                         <p>– Confidence</p>
//                         <p>– Client Handling Capability</p>
//                         <p>– Open to Travel with-in assigned client Meeting</p>
//                         <p>– Good Personality</p>
//                         <p>
//                           <b>Job Responsibilities:</b>
//                         </p>
//                         <p>
//                           – The person will be required to generate new business from
//                           international markets (B2B, B2C), Business directory.
//                         </p>
//                         <p>
//                           – Well Skilled in writing the initial drafts and proposal
//                           based on te client requirements.
//                         </p>
//                         <p>
//                           – Candidates should have relevant experience in selling
//                           Mobile App development and web, ERP services in domestic and
//                           overseas markets.
//                         </p>
//                         <p>
//                           – Understand Technical requirement of customer, Making
//                           presentation to client.
//                         </p>
//                         <p>– Developing Sales Projection Plan.</p>
//                         <p>
//                           – Good Knowledge of Up work LinkedIn and other bidding
//                           portals to get the new prospects and close the deals
//                         </p>
//                         <p>
//                           – Candidate should have good experience in End to End Sales
//                           i.e. from lead Generation to closure of prospects
//                         </p>
//                         <p>
//                           – Candidate must have sound technical knowledge of Android,
//                           iOS and Web Application, latest trends in mobile &amp; Web
//                           technology
//                         </p>
//                         <p>
//                           – Candidates should have experience in reaching out to B2B
//                           and B2C prospects
//                         </p>
//                         <p>
//                           – Candidates should have excellent communication skills,
//                           good selling attitude, and be result oriented
//                         </p>
//                         <p>
//                           – Candidates should be self-motivated to achieve the sales
//                           target
//                         </p>
//                         <p>- Good Proposal writing</p>
//                         <p>– Experience: 0 - 5 years</p>
//                         <p>– No. of Openings : 12</p>
//                         <p>– Job Location: Noida</p>
//                         <p>
//                           – Interested candidates can share updated resume on mailto:
//                           hralobha@alobhatechnologies.com
//                         </p>`
//     },
//     {
//         title: `Project Manager`,
//         hiring: 1,
//         content: `
//       <p>
//                           <b>Job Role &amp; Responsibilities:</b>
//                         </p>
//                         <p>
//                           – Handle &amp; Coordinate all the project management
//                           activities, resources, and act as the point of contact and
//                           communicate project status to all participants.
//                         </p>
//                         <p>
//                           – Dealing &amp; Liaising with clients to identify and define
//                           requirements, scope, and objectives.
//                         </p>
//                         <p>
//                           – Create and maintain comprehensive project documentation,
//                           sprint plans, and reports.
//                         </p>
//                         <p>
//                           – Break projects into doable actions and set timeframes for
//                           each action.
//                         </p>
//                         <p>
//                           – Monitor project progress and handle any issues that arise.
//                         </p>
//                         <p>– Ensure standards and client's requirements are met.</p>
//                         <p>
//                           – Expertise in project management from conception to
//                           delivery.
//                         </p>
//                         <p>
//                           – Solid organizational skills, including multitasking and
//                           time-management.
//                         </p>
//                         <p>
//                           – Certification like PMP/Scrum Master will be preferred.
//                         </p>
//                         <p>– Perform risk management to minimize project risks</p>
//                         <p>
//                           – Establish and maintain relationships with third
//                           parties/vendors
//                         </p>
//                         <p>
//                           – Create and maintain comprehensive project documentation
//                         </p>
//                         <p>
//                           <b>Key Skills:</b>
//                         </p>
//                         <p>
//                           – Excellent client-facing and internal communication skills
//                         </p>
//                         <p>– Excellent written and verbal communication skills</p>
//                         <p>
//                           – Solid organizational skills including attention to detail
//                           and multi-tasking skills
//                         </p>
//                         <p>– Experience : 3-6 Years</p>
//                         <p>– Qualifications : Min.BTech/MCA/Post Graduation</p>
//                         <p>– Job Location: Noida</p>
//                         <p>
//                           – Interested candidate can share updated resume on mailto:
//                           hralobha@alobhatechnologies.com
//                         </p>
//       `
//     },
//     {
//         title: `Node JS Developer`,
//         hiring: 1,
//         content: `
//       <h6 style={{ color: "#737679" }}>
//                           We are looking for a highly capable Node.js developer to
//                           optimize our web-based application performance. You will be
//                           collaborating with our front-end application developers,
//                           designing back-end components, and integrating data storage
//                           and protection solutions.
//                         </h6>
//                         <p>
//                           <b>Responsibilities include:</b>
//                         </p>
//                         <p>
//                           – Developing and maintaining all server-side network
//                           components.
//                         </p>
//                         <p>
//                           – Ensuring optimal performance of the central database and
//                           responsiveness to front-end requests.
//                         </p>
//                         <p>
//                           – Collaborating with front-end developers on the integration
//                           of elements.
//                         </p>
//                         <p>
//                           – Designing customer-facing UI and back-end services for
//                           various business processes.
//                         </p>
//                         <p>
//                           – Developing high-performance applications by writing
//                           testable, reusable, and efficient code.
//                         </p>
//                         <p>
//                           – Implementing effective security protocols, data protection
//                           measures, and storage solutions.
//                         </p>
//                         <p>
//                           – Running diagnostic tests, repairing defects, and providing
//                           technical support.
//                         </p>
//                         <p>
//                           – Documenting Node.js processes, including database schemas,
//                           as well as preparing reports.
//                         </p>
//                         <p>
//                           – Recommending and implementing improvements to processes
//                           and technologies.
//                         </p>
//                         <p>
//                           – Keeping informed of advancements in the field of Node.js
//                           development.
//                         </p>
//                         <p>
//                           <b style={{ color: "#f27135" }}>Requirement</b>
//                         </p>
//                         <p>
//                           – Availability to resolve urgent web application issues
//                           outside of business hours
//                         </p>
//                         {/* <p>– At least two years' experience as a Node.js developer.</p> */}
//                         <p>
//                           – Bachelor's degree in computer science, information
//                           science, or similar.
//                         </p>
//                         <p>
//                           – Extensive knowledge of JavaScript, web stacks, libraries,
//                           and frameworks.
//                         </p>
//                         <p>
//                           – Knowledge of front-end technologies such as HTML5 and
//                           CSS3.
//                         </p>
//                         <p>
//                           – Superb interpersonal, communication, and collaboration
//                           skills.
//                         </p>
//                         <p>
//                           – Object oriented analysis, UML and design using common
//                           design patterns.
//                         </p>
//                         <p>– Exceptional analytical and problem-solving aptitude.</p>
//                         <p>– Great organizational and time management skills.</p>
//                         <p>– Experience- 1.5 years</p>
//                         <p>– Job Location- Noida sec 63</p>
//                         <p>
//                           – Interested candidate can share updated resume on mailto:
//                           hralobha@alobhatechnologies.com
//                         </p>
//       `
//     },
//     {
//         title: `Sales Manager for Alobha Infra`,
//         hiring: 1,
//         content: `
//       <p>
//       <b>Responsibilities include:</b>
//     </p>
//     <p>
//       – Work with buyers, sellers, and renters to sell, buy or
//       rent pre-owned properties throughout the area.
//     </p>
//     <p>
//       – Develop relationships with clients to understand their
//       needs and provide the best real estate solution.
//     </p>
//     <p>
//       – Serve as a representative for clients from start to the
//       end of transaction closing.
//     </p>
//     <p>
//       – Create systematic and consistent lead generation from cold
//       calling, referrals, lead generation services.
//     </p>
//     <p>
//       – Work with area building owners and landlords to assist in
//       sufficient occupancy rates in commercial/industrial
//       buildings.
//     </p>
//     <p>
//       – Maintain highly disciplined schedule for balancing key
//       activities including prospecting, customer appointments,
//       follow-up, and administrative details.
//     </p>
//     <p>
//       – Fully utilize online technology resources, including
//       personal website, to maintain high visibility with prospects
//       and customer base.
//     </p>
//     <p>
//       – Establish and maintained good relations with all clients.
//     </p>
//     <p>
//       – Promote different properties using marketing tools to
//       attract customers including print, electronic and personal
//       interaction.
//     </p>
//     <p>
//       – Research the market regularly to generate lists of
//       properties for prospective clients.
//     </p>
//     <p>
//       – Provide administrative support to clients to ensure a
//       smooth Real Estate transaction.
//     </p>
//     <p>
//       – Market properties through advertisements, open houses,
//       cold calling, networking and using various internet
//       marketing tools, as well as community outreach.
//     </p>
//     <p>– Participate in the company's sales strategy.</p>
//     <p>
//       <b style={{ color: "#f27135" }}>Requirement</b>
//     </p>
//     <p>– Experience- 1 to 3 years</p>
//     <p>
//       – Interested candidates can share updated resume on mailto:
//       hralobha@alobhatechnologies.com
//     </p>
//       `
//     },
//     {
//         title: `Online Bidder/ BDE/ BDM`,
//         hiring: 1,
//         content: `
//       <p>
//                           <b>Roles &amp; Responsibilities (General):</b>
//                         </p>
//                         <p>
//                           – You are responsible for acquiring new clients and figuring
//                           out emerging opportunities in the global market.
//                         </p>
//                         <p>
//                           – Generating Business for Web, Mobile application, &amp;
//                           Software designing &amp; development Services, Virtual
//                           Reality Projects, etc.
//                         </p>
//                         <p>
//                           – Experience in writing Proposals, Bidding for .NET
//                           Projects, Web and Mobile Development, follow-ups,
//                           competition analysis, discussion with offshore clients.
//                         </p>
//                         <p>
//                           – Project price estimation, quote, proposal creation,
//                           talking with Client and closure.
//                         </p>
//                         <p>
//                           – Experience with interacting with clients in US/ UK/
//                           Canada/ Australia/UAE Countries.
//                         </p>
//                         <p>
//                           – Building competitive portfolios on portals to generate
//                           leads.
//                         </p>
//                         <p>
//                           – Getting business through different channels(Upwork,
//                           Freelancer, People per hour, Craiglist, Odesk, Elance, Guru,
//                           Email Marketing Etc.)
//                         </p>
//                         <p>– Quality project selection and bidding.</p>
//                         <p>
//                           – Lead generation through Linkedin, database and other
//                           social networks would be added value.
//                         </p>
//                         <p>
//                           – Collecting and analyzing the project's business
//                           requirements and transferring the same knowledge to
//                           development team.
//                         </p>
//                         <p>
//                           – Providing suggestions to the development team during the
//                           development stage of product to meet the client's business
//                           needs.
//                         </p>
//                         <p>
//                           – Able to Communicate between the Client and the Technical
//                           team.
//                         </p>
//                         <p>
//                           – Assist in enforcement of project deadlines and schedules.
//                         </p>
//                         <p>
//                           – Quickly understands the business issues and data
//                           challenges of client's organization and industry.
//                         </p>
//                         <p>
//                           – Documentation and analyze the required information and
//                           data.
//                         </p>
//                         <p>– Client communication &amp; bridging the gap.</p>
//                         <p>
//                           <b style={{ color: "#f27135" }}>Requirement</b>
//                         </p>
//                         <p>– Experience - 1 to 4 Years</p>
//                         <p>
//                           – Interested candidates can share updated resume on mailto:
//                           hralobha@alobhatechnologies.com
//                         </p>
//       `
//     },
//     {
//         title: `React JS Developer`,
//         hiring: 1,
//         content: `
//       <h6 style={{ color: "#737679" }}>
//                           We are hiring for React Js dev and Full stack dev at Noida
//                           Location interested candidates can share updated resume on
//                           mailto: hralobha@alobhatechnologies.com Job Description is
//                           mentioned below. Reference will be highly apricated
//                         </h6>
//                         <p>
//                           <b>Responsibilities include:</b>
//                         </p>
//                         <p>
//                           – Meeting with the development team to discuss user
//                           interface ideas and applications.
//                         </p>
//                         <p>
//                           – Reviewing application requirements and interface designs.
//                         </p>
//                         <p>– Identifying web-based user interactions.</p>
//                         <p>
//                           – Developing and implementing highly responsive user
//                           interface components using react concepts.
//                         </p>
//                         <p>
//                           – Writing application interface codes using JavaScript
//                           following react.js workflows.
//                         </p>
//                         <p>
//                           – Troubleshooting interface software and debugging
//                           application codes.
//                         </p>
//                         <p>
//                           – Developing and implementing front-end architecture to
//                           support user interface concepts.
//                         </p>
//                         <p>– Monitoring and improving front-end performance.</p>
//                         <p>
//                           – Recommending and implementing improvements to processes
//                           and technologies.
//                         </p>
//                         <p>
//                           – Documenting application changes and developing updates.
//                         </p>
//                         <p>
//                           <b style={{ color: "#f27135" }}>Requirement</b>
//                         </p>
//                         <p>
//                           – Bachelor’s degree in computer science, information
//                           technology, or a similar field.
//                         </p>
//                         {/* <p>– At least two years' experience as a Node.js developer.</p> */}
//                         <p>– Previous experience working as a react.js developer.</p>
//                         <p>
//                           – In-depth knowledge of JavaScript, CSS, HTML, and front-end
//                           languages.
//                         </p>
//                         <p>
//                           – Knowledge of REACT tools including React.js, Webpack,
//                           Enzyme, Redux, and Flux.
//                         </p>
//                         <p>– Experience with user interface design.</p>
//                         <p>
//                           – Knowledge of performance testing frameworks including
//                           Mocha and Jest.
//                         </p>
//                         <p>
//                           – Experience with browser-based debugging and performance
//                           testing software.
//                         </p>
//                         <p>
//                           – Excellent troubleshooting skills &amp; Good project
//                           management skills.
//                         </p>
//                         <p>– Experience – 1-2 years</p>
//                         <p>– Job Location- Noida sec 63</p>
//                         <p>
//                           – Interested candidate can share updated resume on mailto:
//                           hralobha@alobhatechnologies.com
//                         </p>
//       `
//     }, {
//         title: `Inside Sales Executive`,
//         hiring: 1,
//         content: `
//       <p>
//                           We are urgently looking for Inside Sales Executive, to be
//                           responsible for generating leads and meeting sales goals
//                           with proven written and verbal communication
//                           skills.interested candidates can share updated resume on
//                           mailto: hralobha@alobhatechnologies.com
//                         </p>
//                         <p>
//                           <b>Responsibilities include:</b>
//                         </p>
//                         <p>
//                           – Prospecting, generating, qualifying, processing, and
//                           following up on sales leads and appointment setting for the
//                           external sales.
//                         </p>
//                         <p>
//                           – Collaboratively work with the sales, marketing team and
//                           Management team to develop lead generation strategies to
//                           generate lead opportunities with prospective customers.
//                         </p>
//                         <p>
//                           – Initiates lead/demand generation strategies that include
//                           inbound/outbound sales and Providing consistent, concise,
//                           accurate internal and external communications.
//                         </p>
//                         <p>
//                           – Effectively communicate and present the product solution
//                           and value proposition to the prospective customers.
//                         </p>
//                         <p>
//                           – Providing consistent, concise, accurate and timely
//                           weekly/monthly sales lead gen activity reports to
//                           management.
//                         </p>
//                         <p>
//                           – Demonstrates a commitment to the technology industry
//                           staying educated on the new regulations, our product
//                           solutions change, innovations and trends.
//                         </p>
//                         <p>– Achieving sales lead gen and appointment quotas.</p>
//                         <p>
//                           <b style={{ color: "#f27135" }}>
//                             Desired Candidate Profile
//                           </b>
//                         </p>
//                         <p>
//                           – Excellent communication and willing to prospect business
//                           from various sources, including but not limited to Cold
//                           Calling.
//                         </p>
//                         <p>
//                           – Ability to multitask daily projects and commitments and
//                           employ structured selling methods is required.
//                         </p>
//                         <p>– Preference for female candidates. </p>
//       `
//     },
//     {
//         title: `Customer Service Executive <br> for Alobha Infra`,
//         hiring: 1,
//         content: `
//       <p>
//                           We are urgently looking for Sales Executive, to be
//                           responsible for generating leads and meeting sales goals
//                           with proven written and verbal communication
//                           skills.interested candidates can share updated resume on
//                           mailto: hralobha@alobhatechnologies.com
//                         </p>
//                         <p>
//                           <b>Responsibilities include:</b>
//                         </p>
//                         <p>
//                           – Proven experience as Customer service representative /
//                           Executive Role.
//                         </p>
//                         <p>
//                           – Proven track record of successfully meeting sales quota
//                           preferably over the phone.
//                         </p>
//                         <p>– Good knowledge of relevant computer programs.</p>
//                         <p>
//                           – Ability to learn about products and services and
//                           describe/explain them to prospects.
//                         </p>
//                         <p>– Excellent communication and interpersonal skills.</p>
//                         <p>– Cool-tempered and able to handle rejection.</p>
//                         <p>
//                           – Outstanding negotiation skills with the ability to resolve
//                           issues and address complaints.
//                         </p>
//                         <p>
//                           <b style={{ color: "#f27135" }}>
//                             Desired Candidate Profile
//                           </b>
//                         </p>
//                         <p>– Experience - 1 to 3 years</p>
//                         <p>– Preference for female candidates. </p>
//       `
//     },
//     {
//         title: `Business Development Executive`,
//         hiring: 0,
//         content: `.
//       <p>
//                           We are looking for an experienced Business Development
//                           Executive with the following skill sets.
//                         </p>
//                         <p>
//                           <b>Job Description:</b>
//                         </p>
//                         <p>
//                           – Must have Software, Mobile and Web-based Project handling
//                           skills which include understanding and analyzing client’s
//                           requirements, preparing project proposals by analyzing RFPs
//                           with assistance from the technical team.
//                         </p>
//                         <p>
//                           – Must be capable of generation of leads and Online bidding
//                           on portals like FREELANCE, GURU, UP WORK, etc.
//                         </p>
//                         <p>
//                           – Must have good experience in preparing a business
//                           proposal.
//                         </p>
//                         <p>
//                           – Proficient in Proposal Writing, Keeping Follow-ups,
//                           Requirement Gathering.
//                         </p>
//                         <p>
//                           – Prepare Marketing collateral – Presentations, Brochures,
//                           Emails for marketing campaigns and case studies in Mobile
//                           and Web Development Domain (Techno-commercial analysis of
//                           website requirement and application requirement).
//                         </p>
//                         <p>
//                           – Research and build relationships with new clients, Plan
//                           approaches and pitches.
//                         </p>
//                         <p>
//                           – Work with the team to develop proposals as per the
//                           client’s needs, concerns, and objectives.
//                         </p>`
//     }, {
//         title: `Business Analyst`,
//         hiring: 0,
//         content: `
//       <p>
//                           <b>Job Description:</b>
//                         </p>
//                         <p>
//                           – Extensive Expertise in IT project documentation such as
//                           BRD, FRD, SRS, User Manuals, etc.
//                         </p>
//                         <p>– Excellent written and Verbal communication skills.</p>
//                         <p>
//                           – Ability to comprehend business requirements from
//                           internal/external clients.
//                         </p>
//                         <p>
//                           – Experience in creating functional design documents,
//                           business specifications, and test cases.
//                         </p>
//                         <p>
//                           – Good understanding of business/process flows. Experience
//                           of SDLC flow.
//                         </p>
//                         <p>– Basic level understanding of Database too.</p>
//                         <p>
//                           – Commitment to excellence, work to provide the best
//                           customer experience, Excellent Presentation, and customer
//                           service skills.
//                         </p>
//                         <p>
//                           – Ability to think outside the box, the ability to identify
//                           the risks from the business design.
//                         </p>
//                         <p>
//                           – Effective in collaboration, time management, and team
//                           skills
//                         </p>
//                         <p>
//                           – Ensure high productivity and capacity utilization of the
//                           team.
//                         </p>
//       `
//     },
//     {
//         title: `Graphic Designer`,
//         hiring: 0,
//         content: `
      
//       <p>
//                           <b>Job Description:</b>
//                         </p>
//                         <p>
//                           – Must be proficient with graphic designing tools like
//                           Photoshop, Corel Draw, Adobe Illustrator, InDesign etc.
//                         </p>
//                         <p>– Need to be creative, good with ideas &amp; concepts.</p>
//                         <p>
//                           – Proficient in designing logos and banners for websites and
//                           social media platforms.
//                         </p>
//                         <p>
//                           – Understand the requirement briefing of the client and
//                           transform them into tangible designs.
//                         </p>
//                         <p>
//                           – Must be able to create design solutions from concept to
//                           production.
//                         </p>
//                         <p>
//                           – Must have excellent creativity, flair, and a positive
//                           attitude with an eye for design details.
//                         </p>
//                         <p>– Must be able to work with speed and meet deadlines.</p>
//                         <p>
//                           – Ability to contribute as an individual or as a part of the
//                           team as well.
//                         </p>
//                         <p>
//                           <b>Experience: 1-2 years</b>
//                         </p>
//                         <p>
//                           <b>Responsibilities:</b>
//                         </p>
//                         <p>– Provide digital support for marketing campaigns</p>
//                         <p>– Work cross-functionally with other teams</p>
//                         <p>
//                           - Multi-task while designing components of various projects
//                         </p>
//                         <p>
//                           <b>Qualifications</b>
//                         </p>
//                         <p>
//                           - Bachelor's degree in design or related field or relevant
//                           work experience
//                         </p>
//                         <p>
//                           - Proficiency in Adobe Photoshop, InDesign, and Illustrator
//                         </p>`
//     }
// ];
const CareerAccordion = ({ id, title, hiring, content }) => {
    const [show, setShow] = useState(false);

    return (
        <>
            <li className="accordion-item" key={id}>
                <a className="accordion-title " href="javascript:void(0)">
                    {" "}
                    <i className={show ? 'flaticon-line' : "flaticon-plus"} onClick={() => { setShow(!show) }} />
                    {ReactHtmlParser(title)}{" "}
                    <span style={{ float: "right" }}>
                        <p className="text-animition"> {hiring ? 'URGENT HIRING' : ''} </p>
                    </span>
                </a>
                {show && <div className="accordion-content" style={{ display: 'block' }}>
                    {ReactHtmlParser(content)}
                </div>}
            </li>

        </>
    )
}

export default CareerAccordion